import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { IntegrationNotaFiscalModalComponent } from './integration-nota-fiscal-modal.component';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        IntegrationNotaFiscalModalComponent
    ],
    exports: [
        IntegrationNotaFiscalModalComponent
    ]
})
export class IntegrationNotaFiscalSharedModule { }
